// extracted by mini-css-extract-plugin
export var completionBody = "_ep-2";
export var completionCard = "_ep-0";
export var completionFooter = "_ep-3";
export var completionTitle = "_ep-1";